import React, { useState, useEffect } from 'react';

const AsTab = ({ children }) => {
    return <div>{children}</div>;
};

const AsTabContainer = ({
    tabElementStyle,
    tabTextStyle,
    activeTabTextStyle,
    tabPanelStyle,
    onTabClick,
    children,
    initalTab = 0,
    flexTabsDivStyle,
    ...props
}) => {
    const [currentTab, setCurrentTab] = useState(initalTab);

    useEffect(() => {
        handleTabClick(initalTab);
    }, [initalTab]);

    const mainStyle = {
        height: 410,
        width: '100%',
        ...props.style
    };

    flexTabsDivStyle = {
        display: 'flex',
        justifyContent: 'flex-start',
        flexFlow: 'wrap',
        width: '100%',
        ...flexTabsDivStyle
    };

    tabElementStyle = {
        boxSizing: 'border-box',
        height: 39,
        width: 180,
        textAlign: 'center',
        border: '1px solid #D7D7D7',
        borderBottom: '1px solid #FFFFFF',
        paddingTop: 9,
        marginRight: 1,
        ...tabElementStyle
    };

    tabTextStyle = {
        color: '#414141',
        fontFamily: 'Roboto',
        fontSize: 15,
        cursor: 'pointer',
        ...tabTextStyle
    };

    activeTabTextStyle = {
        color: '#414141',
        fontFamily: 'Roboto',
        fontSize: 16,
        fontWeight: 'bold',
        ...activeTabTextStyle
    };

    tabPanelStyle = {
        boxSizing: 'border-box',
        height: mainStyle.height - tabElementStyle.height,
        border: '1px solid #D7D7D7',
        borderRadius: '0 5px 5px 5px',
        backgroundColor: '#FFFFFF',
        boxShadow: '3px 2px 6px 0 rgba(139,104,70,0.33)',
        marginTop: -2,
        overflow: 'hidden',
        ...tabPanelStyle
    };

    const handleTabClick = (tabIndex) => {
        setCurrentTab(tabIndex);

        if (onTabClick) {
            onTabClick(tabIndex);
        }
    };

    function showTabs() {
        if (!Array.isArray(children)) {
            const tabStyle = {
                ...tabElementStyle,
                borderRadius: '0 15px 0 0'
            };

            return (
                <div
                    key={0}
                    style={{
                        ...tabStyle,
                        ...activeTabTextStyle,
                        backgroundColor: '#ffffff'
                    }}
                >
                    {children.props.title}
                </div>
            );
        }

        return children.filter(Boolean).map((tabs, tabIndex) => {
            const tabStyle = {
                ...tabElementStyle,
                borderRadius: tabIndex === 0 ? '0 15px 0 0' : '15px 15px 0 0'
            };

            if (tabIndex === currentTab) {
                return (
                    <div
                        key={tabIndex}
                        style={{
                            ...tabStyle,
                            ...activeTabTextStyle,
                            backgroundColor: '#ffffff'
                        }}
                    >
                        {tabs.props.title}
                    </div>
                );
            } else {
                return (
                    // We can't use !visible here because we don't want people to always have to set visible to true
                    tabs.props.visible !== false && (
                        <div
                            key={tabIndex}
                            onClick={() => handleTabClick(tabIndex)}
                            style={{
                                ...tabStyle,
                                ...tabTextStyle,
                                backgroundColor: '#dadada'
                            }}
                        >
                            {tabs.props.title}
                        </div>
                    )
                );
            }
        });
    }

    const showPanel = (panel) => {
        const tabPanelOverrideStyle = panel.props.style;

        // If there is a height passed in then we change the height of the parent as well as the tab to keep everything in sync.
        // Meaning any components below this tab will not be covered with the tabPanel.
        if (tabPanelOverrideStyle?.height) {
            mainStyle.height =
                tabPanelOverrideStyle.height + tabElementStyle.height;
        }

        return (
            <div style={{ ...tabPanelStyle, ...tabPanelOverrideStyle }}>
                {panel}
            </div>
        );
    };

    return (
        <div style={mainStyle}>
            <div style={flexTabsDivStyle}>{showTabs()}</div>
            {showPanel(
                Array.isArray(children) ? children[currentTab] : children
            )}
        </div>
    );
};

export { AsTabContainer, AsTab };
